<template>
  <v-tooltip right open-delay="200">
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" size="19" color="grey" v-on="on">mdi-help-circle-outline</v-icon>
    </template>

    <span>貴社求人への応募可能性が高い求職者リストです</span>
  </v-tooltip>
</template>

<script>
/** 抽象度が低いコンポーネントなので、moleculesに入れています */
export default {
  name: "HotListInformationIcon",
}
</script>